import { ErrorHandler, Injectable, NgZone } from "@angular/core";
import { AuthService, LogService, PermissionsByRoute } from "@nstep-common/core";

@Injectable({
	providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
	constructor(private logger: LogService,
		private authService: AuthService,
		private ngZone: NgZone) {
	}

	handleError(error: any) {
		try {
			this.logger.fatal('Application has crashed.', error);
		}
		finally {
			this.ngZone.run(() => this.authService.logOut());
		}
	}
}